export var getEventRoot = function getEventRoot(vm) {
  return vm.$root.$options.bvEventRoot || vm.$root;
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/get-event-root.js
// module id = rI7m
// module chunks = 0